module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.resultado) ? _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogPdf),
      callback: function($$v) {
        _vm.dialogPdf = $$v
      },
      expression: "dialogPdf"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(this.resultado.nomePaciente))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "href": _vm.linkDownload
    }
  }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow": "hidden"
    },
    attrs: {
      "id": ("iframeContext_" + (_vm.resultado.id))
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40664a94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PdfDialog.vue
// module id = 370
// module chunks = 1